import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import Feature4 from './Feature4';

import {
  Feature40DataSource,
} from './data.source';
import './less/index.less';
import { Helmet } from 'react-helmet';

export default function Contact() {

  const { isMobile, onEnterChange } = useOutletContext();

  useEffect(() => {
    onEnterChange(false);
  }, []);

  const children = [
    <Feature4
      id="Feature4_0"
      key="Feature4_0"
      dataSource={Feature40DataSource}
      isMobile={isMobile}
    />,
  ];
  return (
    <div
      className="templates-wrapper"
    ><Helmet>
      <meta charSet="utf-8" />
      <title>爱瑟福信息科技(上海)有限公司-联系我们</title>
    </Helmet>
      {children}
    </div>
  );
}
